import React from 'react';
import { SettingCard, SettingCardProps } from '../SettingCard/SettingCard';
import { PrimaryButton, SecondaryButton } from '../../Buttons/Buttons';
import './ButtonSetting.css';

export interface ButtonConfig {
	label: string;
	onClick: () => void;
	variant?: 'primary' | 'secondary';
	disabled?: boolean;
}

export interface ButtonSettingProps extends Omit<
	SettingCardProps,
	'content' | 'className' | 'showContentSeparator'
> {
	buttons: ButtonConfig[];
}

export const ButtonSetting: React.FC<ButtonSettingProps> = ({
	title,
	description,
	buttons,
	settingId,
	showStatusOnValueChange = false,
	statusMessage,
	disabled = false,
	learnMoreUrl,
	learnMoreText,
}) => {
	const renderButton = (button: ButtonConfig, index: number) => {
		const ButtonComponent =
			button.variant === 'primary' ? PrimaryButton : SecondaryButton;
		return (
			<ButtonComponent
				key={index}
				onClick={button.onClick}
				disabled={button.disabled}
				className="button-setting-button"
				ariaLabel={`${button.label} button`}
			>
				{button.label}
			</ButtonComponent>
		);
	};

	return (
		<SettingCard
			title={title}
			description={description}
			settingId={settingId}
			showStatusOnValueChange={showStatusOnValueChange}
			statusMessage={statusMessage}
			disabled={disabled}
			learnMoreUrl={learnMoreUrl}
			learnMoreText={learnMoreText}
			content={
				<div className="button-setting-container">
					{buttons.map((button, index) => renderButton(button, index))}
				</div>
			}
		/>
	);
};
